export default __webpack_public_path__ + "static/media/nic-logo-disabled.19fc72d3.svg";